import {connectDynamicWidgets} from 'instantsearch.js/es/connectors';

const renderCustomDynamicWidgets = (renderOptions, isFirstRender) => {
    const {
        attributesToRender,
        widgetParams,
        instantSearchInstance,
    } = renderOptions;
    widgetParams.container.innerHTML = '';

    attributesToRender.forEach(function (attribute, i) {
        if (!widgetParams.widgetArray[attribute]) {
            return;
        }

        const container = widgetParams.widgetArray[attribute].container;
        const target = container.querySelector('.ais-RefinementList');
        const existingButtons = container.querySelector('.algolia-filter-panel-buttons');
        const existingMobileHeader = container.querySelector('.algolia-filter-panel-mobile-header');

        if (target && !existingMobileHeader) {
            const newHeader = document.createElement('div');
            newHeader.className = 'algolia-filter-panel-mobile-header';
            newHeader.innerHTML = `
                <div class="algolia-filter-panel-mobile-header__headline">${widgetParams.translations['algolia.search.filter.title.' + attribute]}</div>   
                <div class="d-flex">
                    <button class="js-clear-filter btn btn-filter btn-filter--sm" data-filter="${attribute.replaceAll('.', '_')}">
                        ${widgetParams.translations['algolia.search.filter.clear']}
                    </button>
                    <button class="js-apply-filter btn-reset algolia-filter-panel-mobile-header__close" 
                        data-filter="${attribute.replaceAll('.', '_')}" 
                        aria-label="${widgetParams.translations['algolia.search.filter.close']}">
                        <svg class="icon icon-close">
                            <use xlink:href="#icon-close"></use>
                        </svg>
                    </button>
                </div>`;

            target.before(newHeader);
        }

        if (target && !existingButtons) {
            const newButtons = document.createElement('div');
            newButtons.className = 'algolia-filter-panel-buttons';
            newButtons.innerHTML = `
                <button class="js-clear-filter btn btn-filter btn-filter--sm d-none d-md-block" data-filter="${attribute.replaceAll('.', '_')}">
                    ${widgetParams.translations['algolia.search.filter.clear']}
                </button>
                <button class="js-apply-filter btn btn-filter btn-filter--active btn-filter--sm btn-block" data-filter="${attribute.replaceAll('.', '_')}">
                    <span>${widgetParams.translations['algolia.search.filter.apply']}</span>
                </button>`;

            target.after(newButtons);
        }

        $(container).find('.js-nbHits').text(instantSearchInstance?.helper?.lastResults?.nbHits);

        widgetParams.container.appendChild(container);
    });
};

const customDynamicWidgets = connectDynamicWidgets(
    renderCustomDynamicWidgets
);

export {customDynamicWidgets};

